import type { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
    const platformId = inject(PLATFORM_ID);

    // Attach credentials (session cookie)
    let modified = req.clone({ withCredentials: true });

    // Attach CSRF token on mutations
    if (isPlatformBrowser(platformId) && !['GET', 'HEAD'].includes(req.method)) {
        const token = document.cookie
            .split(';')
            .map((c) => c.trim())
            .find((c) => c.startsWith('XSRF-TOKEN='))
            ?.split('=')[1];

        if (token) {
            modified = modified.clone({
                setHeaders: { 'X-XSRF-TOKEN': token },
            });
        }
    }

    return next(modified);
};
